<template>
  <div
    class="modal modal-dosis fade"
    id="modal-editar-dosis"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dosis__dialog"
    >
      <div class="modal-content modal-dosis__content">
        <div class="modal-header modal-dosis__header">
          <button
            type="button"
            class="btn-close modal-dosis__btn-cerrar"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body modal-dosis__body">
          <div class="container modal-dosis__container">
            <form @submit.prevent="handleSubmit">
              <div class="row modal-dosis__row justify-content-center">
                <div
                  class="
                    col-lg-12 col-md-12 col-11
                    text-start
                    mb-2
                    modal-dosis__col
                  "
                >
                  <h2 class="modal-dosis__titulo mb-0">Editar dosis</h2>
                </div>
                <div class="col-12 col-md-12 col-11 modal-dosis__col">
                  <div class="row modal-dosis__row">
                    <div class="col-lg-6 col-md-6 col-12 modal-dosis__col">
                      <hr class="modal-dosis__hr" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-11 modal-dosis__col">
                  <div class="modal-dosis__col mb-3 text-start">
                    <label
                      for="fecha-administracion"
                      class="form-label modal-dosis__label"
                      >Tipo</label
                    >
                    <div class="dropdown dropdown-selector">
                      <button
                        class="dropdown-toggle dropdown-selector__toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {{ selectedTipoVacunaText }}
                        <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                       <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                      </button>
                      <ul class="dropdown-menu dropdown-selector__menu">
                        <li>
                          <a
                            class="dropdown-item dropdown-selector__item"
                            v-for="tipo in ListTipoVacunas"
                            :key="tipo.id_tipo"
                            @click="changeTipoVacuna(tipo.id_tipo, tipo.nombre)"
                          >
                            {{ tipo.nombre }}</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="modal-dosis__col mb-3 text-start">
                    <label
                      for="fecha-administracion"
                      class="form-label modal-dosis__label"
                      >Fecha de administración</label
                    >
                    <input
                      type="date"
                      class="form-control modal-dosis__input-folovid"
                      id="fecha-administracion"
                      placeholder="Ingresa fecha"
                      v-model="fechaAdministracion"
                    />
                  </div>
                  <div class="modal-dosis__col mb-3 text-start">
                    <label
                      for="fecha-prox-dosis"
                      class="form-label modal-dosis__label"
                      >Fecha de la próxima dosis</label
                    >
                    <input
                      type="date"
                      class="form-control modal-dosis__input-folovid"
                      id="fecha-prox-dosis"
                      placeholder="Ingresa fecha"
                      v-model="fechaProximaDosis"
                    />
                  </div>
                </div>
                <div
                  class="col-lg-6 col-md-6 col-11 modal-dosis__col text-start"
                >
                  <label
                    for="input-imagen"
                    class="form-label modal-dosis__label"
                  >
                    Adjunta certificado Covid-19
                  </label>
                  <div class="row modal-dosis__row">
                    <div
                      class="
                        col-12
                        position-relative
                        modal-dosis__col modal-dosis__col--bg-gris-claro
                        text-center
                      "
                    >
                      <div
                        class="modal-dosis__div-input-archivo"
                        :style="{ borderColor: colorPrimario }"
                      >
                        <!-- Vista previa de la imagen, sólo aparece cuando se sube el archivo -->
                        <img
                          v-if="preview_imagen != ''"
                          :src="preview_imagen"
                          class="modal-dosis__vista-previa-img"
                          alt="Vista previa de la imagen"
                        />
                        <!-- Vista previa de la imagen, sólo aparece cuando se sube el archivo -->

                        <img
                          v-else
                          :src="preview_before"
                          class="modal-dosis__vista-previa-img"
                          alt="Imagen anterior"
                        />

                        <!-- <span v-else class="modal-dosis__texto-input-archivo">
                          <img
                            :src="preview_before"
                            class="modal-dosis__icono-subir"
                            alt="Ícono de reconocimiento"
                          />
                          <br />
                          Haz click aquí
                        </span> -->
                      </div>

                      <input
                        class="form-control modal-dosis__input-archivo"
                        type="file"
                        id="formFile"
                        @change="handleFile"
                        ref="file"
                      />
                      <!-- Quitar la imagen, sólo aparece cuando se sube el archivo -->
                      <button
                        class="modal-dosis__quitar-img"
                        v-if="imagen != '' && preview_imagen != ''"
                        @click="borrarImg"
                      >
                        x
                      </button>
                      <!-- Quitar la imagen, sólo aparece cuando se sube el archivo -->
                    </div>
                  </div>
                </div>
                <div
                  class="
                    col-lg-12 col-md-12 col-11
                    text-end
                    pt-3
                    modal-dosis__col modal-dosis__col--borde-sup
                  "
                >
                  <button
                    type="button"
                    class="modal-dosis__btn-gris me-3 px-4 py-1"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancelar
                  </button>
                  <button
                    class="modal-dosis__btn-lila px-4 py-1"
                    data-bs-toggle="modal"
                    data-bs-target="#modal-exito"
                    :disabled="validateForm()"
                    :style="{ backgroundColor: colorPrimario }"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="modal-footer modal-dosis__footer pb-4"></div>
      </div>
    </div>
  </div>
</template>

<script>
//import { gql } from "graphql-tag";
import { mapState ,mapActions } from "vuex";

export default {
  name: "ModalEditVacuna",
  data() {
    return {
      id_vacuna: "",
      tipo: "",
      selectedTipoVacuna: "",
      selectedTipoVacunaText: "Seleccionar tipo",
      fechaAdministracion: "",
      fechaProximaDosis: "",
      imagen: "",
      formato_imagen: "",
      preview_imagen: "",
      imagen_before: "",
      preview_before: "",
    };
  },
  computed:{
    ...mapState("FolovidModule", ["ListTipoVacunas"]),
  },
  created() {
    this.getTipoV();
  },
  methods: {
    ...mapActions("FolovidModule", ["editarVacunaUsuario", "getTipoVacuna"]),
    async getTipoV(){
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk
      }
      await this.getTipoVacuna(data_);
    },
    changeTipoVacuna(id, nombre) {
      this.selectedTipoVacuna = id;
      this.selectedTipoVacunaText = nombre;

      console.log(this.selectedTipoVacuna, this.selectedTipoVacunaText);
    },
    handleFile() {
      const promise = this.getBase64(this.$refs.file.files[0]);
      const x = this;
      promise.then(function (result) {
        x.imagen = result.split(",")[1];
        x.preview_imagen = result;

        if (x.imagen && x.imagen != "") {
          x.formato_imagen = x.$refs.file.files[0]["type"];
        }
      });
    },
    borrarImg() {
      this.imagen = "";
      this.formato_imagen = "";
      this.preview_imagen = "";
    },
    async handleSubmit() {
        let data_ = {
          id_vacuna: this.id_vacuna,
          id_tipo: this.selectedTipoVacuna,
          fecha_dosis: this.fechaAdministracion,
          fecha_siguiente_dosis: this.fechaProximaDosis,
          imagen: this.imagen,
          formato_imagen: this.formato_imagen,
          id_usuario: this.$ls.get("user").id_usuario,
          id_empresa: this.$ls.get("user").id_empresa_fk
        }
        await this.editarVacunaUsuario(data_).then(edit_vacuna=>{
            if (edit_vacuna) {
              document
                .getElementById("modal-add-dosis")
                .querySelector(".btn-close")
                .click();

              document.getElementById("btn-modal-exito").click();
            }
        });
    },
    validateForm() {
      return (
        this.selectedTipoVacuna == "" ||
        this.fechaAdministracion == "" ||
        this.fechaProximaDosis == ""
      );
    },
  },
  mounted() {
    this.$root.$on("abrir-modal-editar", (vacuna) => {
      this.id_vacuna = vacuna.id_vacuna;
      this.selectedTipoVacuna = vacuna.tipo_vacuna.id_tipo;
      this.selectedTipoVacunaText = vacuna.tipo_vacuna.nombre;
      this.fechaAdministracion = vacuna.fecha_dosis;
      this.fechaProximaDosis = vacuna.fecha_siguiente_dosis;
      this.imagen_before = vacuna.url_imagen;
      this.preview_before = vacuna.url_imagen;
    });
  },
};
</script>
